import { useRouter } from 'next/router';
import { APP_IMG, SHOW_COMMEMORATE, SHOW_RIBBON } from 'src/constants';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';
import WidgetSubscribe from './widget-subscribe';

const HeaderSubscribe = ({ sessionSevId }) => {
  const router = useRouter();

  return (
    <>
      <WidgetWrapper className='header-subscribe'>
        <div></div>
        <div className='logo-header'>
          {router.asPath === '/' ? (
            <h1>
              <span>ข่าวล่าสุด วิเคราะห์ข่าวเศรษฐกิจ - กรุงเทพธุรกิจ </span>
              <a
                className='logo-img'
                href='/'
                title='กรุงเทพธุรกิจ'
                aria-label='หน้าแรก กรุงเทพธุรกิจ'
                //! DATALAYER
                onClick={() =>
                  sendDataLayerGlobal({
                    type: DATALAYER_TYPE.TRACK_POSITION,
                    router: router?.pathname,
                    position: 'on:header',
                    section: 'header',
                    data: {
                      title: 'logo',
                      heading: 'logo'
                    }
                  })
                }
              >
                {SHOW_RIBBON === 'true' && (
                  <div className='ribbon'>
                    <img src={`${APP_IMG}/logo-ribbon-black-2.png`} alt='กรุงเทพธุรกิจ' width='35px' height='35px' />
                  </div>
                )}
                <img
                  className='logo'
                  src={`${APP_IMG}/new-logo-primary.webp`}
                  alt='กรุงเทพธุรกิจ'
                  width='400'
                  height='100'
                  style={{
                    width: '100%',
                    maxWidth: '400px',
                    height: 'auto', // ← ไม่ fix height
                    aspectRatio: '400/100',
                    filter: SHOW_RIBBON === 'true' ? 'brightness(0)' : SHOW_COMMEMORATE === 'true' ? 'grayscale(1)' : 'unset'
                  }}
                />
              </a>
            </h1>
          ) : (
            <a
              href='/'
              className='logo-img'
              aria-label='หน้าแรก กรุงเทพธุรกิจ'
              //! DATALAYER
              onClick={() =>
                sendDataLayerGlobal({
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  position: 'on:header',
                  section: 'header',
                  data: {
                    title: 'logo',
                    heading: 'logo'
                  }
                })
              }
            >
              <img
                className='logo'
                src={`${APP_IMG}/new-logo-primary.webp`}
                alt='กรุงเทพธุรกิจ'
                width='400'
                height='100'
                style={{
                  width: '100%',
                  maxWidth: '400px',
                  height: 'auto', // ← ไม่ fix height
                  aspectRatio: '400/100',
                  filter: SHOW_RIBBON === 'true' ? 'brightness(0)' : SHOW_COMMEMORATE === 'true' ? 'grayscale(1)' : 'unset'
                }}
              />
            </a>
          )}
        </div>
        <WidgetSubscribe sessionSevId={sessionSevId} />
      </WidgetWrapper>
    </>
  );
};

export default HeaderSubscribe;

const WidgetWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  max-width: 1300px;
  margin: auto;
  padding: 0 10px;
  .logo-img {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .logo-header {
    width: 100%;
    max-width: 1280px;
    min-height: 150px;
    margin: auto;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 15px 15px 25px;
    @media (max-width: 1024px) {
      min-height: 90px;
      margin: 10px 15px 9px;
    }
    h1 {
      margin-bottom: 0;
    }
    a {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    span {
      text-indent: 1000em;
      white-space: nowrap;
      overflow: hidden;
      display: none !important;
      // display: block;
      position: fixed;
      width: 100%;
    }
    .ribbon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      max-width: 100%;
      img {
        width: 70px;
        height: 70px;
      }
      @media (max-width: 540px) {
        img {
          width: 50px;
          height: 50px;
        }
      }
    }
    .logo {
      display: block;
      width: 420px;
      max-width: 100%;
      height: auto;

      @media (max-width: 540px) {
        width: 320px;
      }
    }
  }
`;
